import useUserPermissions from 'hooks/useUserPermissions';
import React from 'react';
import { Navigate } from 'react-router-dom';

export const InternalAdminOnlyWrapper = ({ children }) => {
    const { isInternalAdmin } = useUserPermissions();

    if (!isInternalAdmin) {
        return <Navigate to={`/${window.location.search}`} replace />;
    }

    return <>{children}</>;
};
